<div class="filter-component-container">
    <h1>
        Filters
    </h1>
    <form class="filter-form" [formGroup]="filterForm">
        <div class="main-filter-container">
            <mat-form-field class="main-filter">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="startDate" placeholder="Start date">
                    <input matEndDate formControlName="endDate" placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                @if (filterForm.controls.startDate.hasError('matStartDateInvalid')) {
                <mat-error>Invalid start date</mat-error>
                }
                @if (filterForm.controls.endDate.hasError('matEndDateInvalid')) {
                <mat-error>Invalid end date</mat-error>
                }
            </mat-form-field>

            <mat-form-field class="main-filter">
                <mat-label>Customers</mat-label>
                <mat-select formControlName="customers" required multiple>
                    @for (customer of customers; track customer) {
                    <mat-option [value]="customer">{{customer}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <div class="apply-button">
                <button mat-flat-button (click)="onApply()" id="apply-button">Apply</button>
            </div>
            <div class="apply-button">
                <button mat-stroked-button (click)="onReset()" id="reset-button">Reset</button>
            </div>
        </div>
        <mat-accordion class="no-radius expansion-panel">
            <mat-expansion-panel class="no-radius mat-elevation-z0" id="advanced-filters">
                <mat-expansion-panel-header>
                    <mat-panel-title> Advanced Filters </mat-panel-title>
                </mat-expansion-panel-header>
                <p>
                    Enter more advanced filters below as comma seperated values.
                    "Bug IDs" will have to match exactly.
                    "Use Cases", "Issue Groups" and "Carts" only have to partially match and are all case-insensitive.
                </p>
                <div id="advanced-filters-fields">
                    <mat-form-field appearance="outline">
                        <mat-label>Bug IDs</mat-label>
                        <input matInput formControlName="bugIds" placeholder='Example: "1001, 2345"'>
                        <mat-hint>
                            Comma seperated list
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Use Cases</mat-label>
                        <input matInput formControlName="useCases" placeholder='Example: "UC1, UC3, 5"'>
                        <mat-hint>
                            Comma seperated list
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Issue Groups</mat-label>
                        <input matInput formControlName="issueGroups" placeholder='Example: "lidar, mecanum"'>
                        <mat-hint>
                            Comma seperated list
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Carts</mat-label>
                        <input matInput formControlName="carts" placeholder='Example: "Cart 1, cart 2"'>
                        <mat-hint>
                            Comma seperated list
                        </mat-hint>
                    </mat-form-field>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </form>
</div>
